import { render, staticRenderFns } from "./agreenment.vue?vue&type=template&id=473b34ba&scoped=true";
import script from "./agreenment.vue?vue&type=script&lang=js";
export * from "./agreenment.vue?vue&type=script&lang=js";
import style0 from "./agreenment.vue?vue&type=style&index=0&id=473b34ba&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "473b34ba", null);
export default component.exports;